import React, { useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';

export const SocketContext = React.createContext<Socket>(null);

type SocketProviderProps = {
  children?: React.ReactNode;
};

export const SocketProvider = ({ children }: SocketProviderProps) => {
  const [socket, setSocket] = useState<Socket>(null);

  const init = () => {
    if (!socket && process.browser) {
      setSocket(io(process.env.NEXT_PUBLIC_SOCKETIO_URL, { transports: ['websocket'] }));
    }
  };

  const disconnect = () => {
    if (socket) {
      socket.off('disconnect');
      socket.disconnect();
      setSocket(null);
    }
  };

  useEffect(() => {
    // Teardown
    init();
    return () => {
      disconnect();
    };
  }, []);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};
